// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressValidationModalStyles } from "@rpsc/App/Components/Addresses/AddressValidationModal";
import IconEdit from "@rpsc/XDL/Icons/IconEdit";
import { color, createLinkIconStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

addressValidationModalStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        background: ${color("common.border")};
        padding: 5px;
        border-radius: 2px;
    `,
};
addressValidationModalStyles.title = {
    variant: "h5",
};
addressValidationModalStyles.shipToAddress = {
    css: css`
        border-radius: 2px 0 0 2px;
        display: flex;
        flex: 1;
        padding: 12px;
        background: ${color("common.white")};
        flex-direction: column;
    `,
};

addressValidationModalStyles.recommendedAddress = {
    css: css`
        border-radius: 0px 2px 2px 0px;
        display: flex;
        flex: 1;
        padding: 12px;
        flex-direction: column;
    `,
};

addressValidationModalStyles.currentAddressActions = {
    css: css`
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 12px;
        row-gap: 15px;
    `,
};

addressValidationModalStyles.editLink = {
    ...createLinkIconStyles(IconEdit),
};
addressValidationModalStyles.useAddress = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
addressValidationModalStyles.acceptButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: auto;
    `,
};

addressValidationModalStyles.notify = {
    css: css`
        max-width: 100%;
    `,
};
